import { logger } from "@/helpers/tslog";
import { getToken } from "@/utils/localstorage";
import axios from "axios";

const apiUrl = process.env.API_URL;
export async function resetLLM() {
  console.log("Resetting LLM...");
  const authToken = await getToken();
  const result = await axios.post(
    `${apiUrl}/alpha-create/reset`,
    {},
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
  logger.info("LLM reset response:", result.data);
}

export async function resetEditLLM() {
  const authToken = await getToken();
  const result = await axios.post(
    `${apiUrl}/alpha-edit/reset`,
    {},
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
  logger.info("LLM reset response:", result.data);
}
